import BasicSelect from "./BasicSelect";
export default BasicSelect;
